export const AXIOS_INITIALIZED = 'AXIOS_INITIALIZED';
